import Address from "./modules/AddressApi"
import Agenda from "./modules/AgendaApi"
import BankAccount from './modules/BankAccountApi'
import Bank from './modules/BankApi'
import Client from "./modules/ClientApi"
import Comission from './modules/ComissionApi'
import Company from "./modules/CompanyApi"
import Building from "./modules/BuildingApi"
import ClientBlockLog from "./modules/ClientBlockLogApi"
import Contact from './modules/ContactApi'
import Deal from "./modules/DealApi"
import Modality from "./modules/ModalityApi"
import Driver from "./modules/DriverApi"
import Financial from "./modules/FinancialsApi"
import PaymentOption from "./modules/PaymentOptionApi"
import Prospect from "./modules/ProspectApi"
import Region from "./modules/RegionApi"
import RemoteAddress from './modules/RemoteAddressApi'
import RemoteBankAccount from './modules/RemoteBankAccountApi'
import RemoteContact from './modules/RemoteContactApi'
import Supplier from './modules/SupplierApi'
import SupplierV2 from './modules/SupplierApiV2'
import Order from "./modules/OrderApi"
import Truck from './modules/TruckApi'
import WholesaleDriver from './modules/WholesaleDriverApi'
import ClientPortfolio from "./modules/ClientPortfolioApi"
import DefaultClientPayment from "./modules/DefaultClientPaymentApi"
import Brand from "./modules/BrandApi"
import Product from "./modules/ProductApi"
import PickupLocation from "./modules/PickupLocationApi"
import Segment from "./modules/SegmentApi"
import Bonus from "./modules/BonusApi"
import ClientFinancialHistoric from "./modules/ClientFinancialHistoricApi"
import ClientOrdersHistory from "./modules/ClientOrdersHistoryApi"
import CreditLog from "./modules/CreditLogApi"
import SellerDailyReport from "./modules/SellerDailyReportApi"
import Holiday from "./modules/HolidayApi"
import SellerDashboard from "./modules/SellerDashboardApi"
import ProductPrice from "./modules/ProductPriceApi"
import BrandCompanyCode from "./modules/BrandCompanyCodeApi"
import PalletsHistory from "./modules/PalletsHistoryApi"
import EconomicGroup from "./modules/EconomicGroupApi"
import PaymentReminderConfig from "./modules/PaymentReminderApi"
import WhatsappInstanceApi from "./modules/WhatsappInstanceApi"
import WhatsappMessage from "./modules/WhatsappMessageApi"
import ShippingRate from "./modules/ShippingRateApi"


export default {
  Address,
  Agenda,
  BankAccount,
  Bank,
  Bonus,
  Building,
  Client,
  ClientBlockLog,
  Comission,
  Company,
  Contact,
  Deal,
  Modality,
  Driver,
  Financial,
  PaymentOption,
  Prospect,
  Region,
  RemoteAddress,
  RemoteBankAccount,
  RemoteContact,
  Supplier,
  SupplierV2,
  Order,
  Truck,
  WholesaleDriver,
  DefaultClientPayment,
  ClientPortfolio,
  Brand,
  Product,
  PickupLocation,
  Segment,
  ClientFinancialHistoric,
  ClientOrdersHistory,
  CreditLog,
  SellerDailyReport,
  SellerDashboard,
  Holiday,
  ProductPrice,
  BrandCompanyCode,
  PalletsHistory,
  EconomicGroup,
  PaymentReminderConfig,
  WhatsappInstanceApi,
  WhatsappMessage,
  ShippingRate,
}